export const defaultState = {
  myActivities: [],
  myContracts: [],
  submissions: [],
  fiscalYears: [],
  subordinatePendingReports: {
    allReports: 0,
    forActiveReports: 0,
    forExitedReports: 0,
  },
};
